import { Injectable } from '@angular/core';
import { AbstractSensorContentStore2D } from '../../shared/state/abstract-sensor-content-store-2d';
import { VideoContentState } from './video-content-state';

@Injectable()
export class VideoContentStore extends AbstractSensorContentStore2D<VideoContentState> {
  constructor(initialState: VideoContentState) {
    super(initialState, 'VideoContentStore');
  }
}
